import StoreProvider from 'store/StoreProvider';

import { SnackbarProvider } from 'notistack';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import Language from './Language';

import Router from 'components/Router';
import ServerDown from 'components/ServerDown';

/**
 * This component is used to configure the app before it's rendered
 */
function Config() {
	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<StoreProvider>
				<SnackbarProvider>
					<Language>
						<ServerDown>
							<Router />
						</ServerDown>
					</Language>
				</SnackbarProvider>
			</StoreProvider>
		</LocalizationProvider>
	);
}

export default Config;
